import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	unassigned: {
		id: 'software-deployments.top-filters.epic-filter.unassigned',
		defaultMessage: 'Issues without epic',
		description: 'Epic filter option for issues that do not have an epic parent assigned',
	},
});
